import React, { useState, useEffect } from "react";

import moment from "moment/moment";
import axiosInstance from "../../../axios";
import { Loading } from "../../Other/Loading";
import Pagination from "../Teachers/MemberList/Pagination";

const QuizResult = () => {
  const [fetchRecord, setFetchRecord] = useState();
  const [totalQuizPage, setTotalQuizPage] = useState();
  const [pageNum, setPageNum] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get(`/test/list?page=${pageNum}`)
      .then((res) => {
        setLoading(false);
        setTotalQuizPage(res?.data?.data?.total_page);
        setFetchRecord(res?.data?.data?.data);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }, [pageNum]);

  return (
    <div className="width-0">
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="page-data-new">
            <div>
              {fetchRecord && fetchRecord?.length > 0 ? (
                <p className="showing-result">
                  Showing {pageNum} page of {totalQuizPage} results
                </p>
              ) : (
                <p className="showing-result">Showing 0 result</p>
              )}
            </div>
          </div>
          <div className="instructor-table">
            {fetchRecord && fetchRecord?.length > 0 ? (
              <table className="table-width-100">
                <thead>
                  <th>Sr.no</th>
                  <th>Quiz Name</th>
                  <th>Wrong Answer</th>
                  <th>Right Answer</th>
                  <th>createdOn</th>
                  <th>Total Question</th>
                  <th>Percentage</th>
                  <th></th>
                </thead>
                <tbody>
                  {fetchRecord?.map((ele, index) => {
                    return (
                      <tr key={index}>
                        <td className="cell">
                          {pageNum * fetchRecord?.length -
                            fetchRecord?.length +
                            index +
                            1}
                        </td>
                        <td className="cell">{ele.name}</td>
                        <td className="cell">{ele.wrongAns}</td>
                        <td className="cell">{ele.rightAns}</td>
                        <td className="cell">
                          {ele.createdOn
                            ? moment(ele?.createdOn).format("DD/MM/YYYY")
                            : "01/12/22"}
                        </td>
                        <td className="cell">{ele.rightAns + ele.wrongAns}</td>
                        <td className="cell">
                          {(
                            (ele.rightAns / (ele.wrongAns + ele.rightAns)) *
                            100
                          ).toFixed(0)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <h2 className="no-data-found">No data found</h2>
            )}
          </div>

          <div className="pageNumbers-sudents">
            {fetchRecord && fetchRecord?.length > 0 && (
              <Pagination
                className="pageNumbers-sudents"
                currentPage={pageNum}
                totalCount={8}
                pageSize={totalQuizPage}
                onPageChange={(page) => setPageNum(page)}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};
export default QuizResult;
